<template>
  <div id="page" class="container-fluid">
    <div class="row header mx-4 my-4">
      <div class="col my-3">
        <h1>Estimate Facility Fees
          <b-button class="ml-3" variant="outline-orange" @click="addEstimateAscFee">
            <font-awesome-icon class="orange" icon="plus"/>
            New
          </b-button></h1>
      </div>
    </div>
    <div class="container-fluid">
      <div class="row data-table-header">
        <div class="col-2">Description</div>
        <div class="col-2">Amount</div>
        <div class="col-2">Fee Type</div>
        <div class="col-2">Covered Item</div>
        <div class="col-1">Default</div>
        <div class="col-3"></div>
      </div>
      <div class="row data-table-row" v-for="estimateAscFee in estimateAscFees" :key="estimateAscFee.organizationEstimateAscFeeId">
        <div class="column col-2">{{ estimateAscFee.description }}</div>
        <div class="column col-2">{{ formatNumberOrPercent(estimateAscFee)}}</div>
        <div class="column col-2">{{ estimateFeeType(estimateAscFee.feeType) }}</div>
        <div class="column col-2">{{ itemIsCovered(estimateAscFee.coveredItem) }}</div>
        <div class="column col-1">{{ isDefault(estimateAscFee.appliedByDefault) }}</div>
        <div class="col-3 text-right">
          <button title="Edit" @click.prevent="editEstimateAscFee(estimateAscFee)" type="button" class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'edit']"/>Edit
          </button>
          <button title="Delete" @click.prevent="deleteEstimateAscFee(estimateAscFee)" type="button" class="btn btn-outline-orange m-1 wide-button">
            <font-awesome-icon class="orange mr-2" :icon="['far', 'trash-alt']"/>Delete
          </button>
        </div>
      </div>
    </div>
    <estimate-asc-fee-modal :edit-estimate-asc-fee="editingEstimateAscFee" @updated="estimateAscFeesUpdated" :visible="showingEstimateAscFeeModal" @update:visible="visible => showingEstimateAscFeeModal = visible"></estimate-asc-fee-modal>
  </div>
</template>

<script>
  import EstimateAscFeeModal from '@/components/EstimateAscModal.vue'
  import api from '@/services/api'
  import ErrorsMixin from '@/mixins/ErrorsMixin'
  import AnalyticsMixin from '@/mixins/AnalyticsMixin'

  export default {
    name: 'EstimateAscFee',
    components: { EstimateAscFeeModal },
    mixins: [ErrorsMixin, AnalyticsMixin],
    data () {
      return {
        estimateAscFees: [],
        estimateAscFeeId: 0,
        editingEstimateAscFee: {},
        showingEstimateAscFeeModal: false
      }
    },

    methods: {
      loadData () {
        api.get('Dashboard/EstimateAscFees').then(response => {
          this.trackEvent('EstimateAscFee', 'Load', 'ResponseTime', response.config.requestDuration)
          this.estimateAscFees = response.data
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('EstimateAscFee', 'LoadError', error.message)
            this.$log.error('Error attempting to load estimate asc fees: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        })
      },
      deleteEstimateAscFee (estimateAscFee) {
        api.delete('Dashboard/EstimateAscFee/' + estimateAscFee.organizationEstimateAscFeeId).then(() => {
          this.loadData()
        }).catch(error => {
          if (!this.$store.canHandleNetworkError(error)) {
            this.trackEvent('EstimateAscFee', 'DeleteError', error.message)
            this.$log.error('Error attempting to delete estimate asc fees: ' + error.message, error)
            this.setFromApiErrorResponse(error)
          }
        })
      },
      addEstimateAscFee () {
        this.editingEstimateAscFee = {
          amount: '',
          appliedByDefault: false,
          coveredItem: false,
          description: '',
          feeType: null,
          isDeleted: false,
          shortCode: ''
        }
        this.showingEstimateAscFeeModal = true
      },
      editEstimateAscFee (estimateAscFee) {
        this.editingEstimateAscFee = estimateAscFee
        this.showingEstimateAscFeeModal = true
      },
      estimateAscFeesUpdated () {
        this.showingEstimateAscFeeModal = false
        this.loadData()
      },
      formatNumberOrPercent (estimateAscFee) {
        if (estimateAscFee && estimateAscFee.feeType === 'FlatAmount') {
          return '$' + estimateAscFee.amount.toFixed(2).replace(/\d(?=(\d{3})+\.)/g, '$&,')
        } else if (estimateAscFee.amount && (estimateAscFee.feeType === 'PercentageOfCodes' || 'PercentageOfTotal')) {
          return estimateAscFee.amount * 100 + '%'
        }
      },
      estimateFeeType (type) {
        if (type === 'FlatAmount') {
          return 'Flat Amount'
        }
        if (type === 'PercentageOfCodes') {
          return 'Percentage Of Codes'
        }
        if (type === 'PercentageOfTotal') {
          return 'Percentage Of Total'
        }
      },
      itemIsCovered (covered) {
        if (covered === true) {
          return 'Yes'
        }
        if (covered === false) {
          return 'No'
        }
      },
      isDefault (appliedDefault) {
        if (appliedDefault === true) {
          return 'Yes'
        }
        if (appliedDefault === false) {
          return 'No'
        }
      }
    },
    created () {
      this.loadData()
    }
  }
</script>
